import { QualificationStandardsInterface } from "../../../common/interfaces/QualificationStandardsInterface";
import { SelectFieldType } from "../../../common/types/Types";

export const getQualificationStandardOptions = (
    qualificationStandardData?: QualificationStandardsInterface[],
): SelectFieldType[] => {
    if (!qualificationStandardData) {
        return [];
    }

    return qualificationStandardData.map((qualificationStandard) => ({
        value: qualificationStandard.id.toString(),
        label: qualificationStandard.tag,
    }));
};
